import { useStaticQuery, graphql } from 'gatsby'

/**
 * Get all posts
 * @return {Array} Array of posts
 */
const useGravatar = () => {
	const { gravatar: { url } = {} } = useStaticQuery(graphql`
		query {
			gravatar(email: { eq: "info@aider.nu" }) {
				url
			}
		}
	`)

	return url
}

export default useGravatar
